import { z } from '@/libs/zod';

export const personalDataSchema = z.object({
  document: z.string(),
  fullname: z.string(),
  email: z.string().email(),
  phone: z.string(),
});

export type PersonalData = z.infer<typeof personalDataSchema>;
